import { ReportDiffCountMap } from '../models/ReportDiffCountMap';

export class ReportDiffCountMapMapper {
  mapGQLModel(data: any): ReportDiffCountMap {
    return new ReportDiffCountMap(data.high, data.med, data.low, data.passed);
  }
}
